import React, { useState } from "react";
import * as ReactBootstrap from "react-bootstrap";
import * as components from "../../../components";
import { useEstimation } from "./hooks";
import { AddPartSlider } from "./AddPartSlider";
import { PrintEstimateSlider } from "./PrintEstimateSlider";
import { EstimationLine } from "./EstimationLine";
import { EstimationsProps } from "./types";

const Estimations = ({ ticket, onUpdate }: EstimationsProps) => {
  const [openForm, setOpenForm] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);

  const total = ticket.quotation_records?.reduce(
    (sum, { final_amount }) => sum + (parseFloat(final_amount ?? "0") || 0),
    0
  ) ?? 0;

  const { createEstimation } = useEstimation(ticket, onUpdate, () => setOpenForm(false));

  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6">Estimations</ReactBootstrap.Col>
          <ReactBootstrap.Col xs="6" className="text-end">
            <AddPartSlider
              open={openForm}
              onAfterOpen={() => setOpenForm(true)}
              onClose={() => setOpenForm(false)}
              ticket={ticket}
              onSubmit={createEstimation}
            />
            <PrintEstimateSlider
              open={openPrint}
              onAfterOpen={() => setOpenPrint(true)}
              ticket={ticket}
              total={total}
            />
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Title>

      <ReactBootstrap.Card.Body>
        {ticket.quotation_records.length > 0 ? (
          <components.ItemList
            itemRenderer={(index) => (
              <ReactBootstrap.Col key={ticket.quotation_records[index].url}>
                <EstimationLine
                  ticket={ticket}
                  onUpdate={onUpdate}
                  part_request={ticket.quotation_records[index]}
                />
              </ReactBootstrap.Col>
            )}
            length={ticket.quotation_records.length}
          />
        ) : (
          <ReactBootstrap.Alert variant="info">
            No Previous Estimation Line found.
          </ReactBootstrap.Alert>
        )}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  );
};

export default Estimations;
